import { useEffect } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "ramda";

import { usePage, useLoading, useGtm, useRouter } from "hooks";
import MainTitle from "components/MainTitle";
import MetaTags from "components/MetaTags";
import PagePresenter from "presenters/PagePresenter";
import { jjLogger } from "utils/logUtils";
import { appRoutes } from "routes";
import { PAGE_TYPES } from "enums/pageModules";

import Content from "./components/Content";

const Page = ({ slug, type = PAGE_TYPES.PAGE }) => {
  const { trackVirtualPageView } = useGtm();
  const { loadCategoryPage, loadPage, page, resetPage } = usePage();
  const loader = type === PAGE_TYPES.CATEGORY ? loadCategoryPage : loadPage;
  const { func: loadPageWithLoader, isFinished } = useLoading(loader);
  const { history, location } = useRouter();

  useEffect(() => {
    if (slug) {
      loadPageWithLoader(slug)
        .then((pageLoaded) => {
          const virtualPageViewObject = PagePresenter.virtualPageViewObject(pageLoaded);

          if (!isEmpty(virtualPageViewObject)) {
            trackVirtualPageView(virtualPageViewObject);
          }
        })
        .catch((error) => {
          jjLogger.logError(`Page.js loadPageWithLoader: ${error}`);
          history.push({ pathname: appRoutes.page404Path(), state: { referrer: location.pathname } });
        });
    }

    return () => {
      resetPage();
    };
  }, [slug]);

  return (
    <>
      <Content page={page} isLoading={!isFinished} />
      <MainTitle title={PagePresenter.seoTitle(page)} />
      <MetaTags>
        <meta name="description" content={PagePresenter.seoDescription(page)} />
        <meta name="og:title" content={PagePresenter.seoOgTitle(page)} />
        <meta name="og:description" content={PagePresenter.seoOgDescription(page)} />
        {!PagePresenter.seoIndexable(page) && <meta name="robots" content="noindex" />}
      </MetaTags>
    </>
  );
};

Page.propTypes = {
  slug: PropTypes.string,
  type: PropTypes.string,
};

export default Page;
